import {
    Description,
    Field,
    Select as HeadlessSelect,
    Label,
} from '@headlessui/react';
import { useId } from 'react';

const Select = ({
    id,
    label,
    description,
    error,
    required = false,
    disabled = false,
    placeholder,
    options,
    children,
    ...props
}) => {
    let uuid = useId();

    return (
        <Field disabled={disabled}>
            {label && (
                <Label
                    htmlFor={id || uuid}
                    className='mb-1 block text-sm/6 font-medium text-gray-900'
                >
                    {label}
                    {required && (
                        <span className='inline-block pl-1 text-red-800'>
                            *
                        </span>
                    )}
                </Label>
            )}
            {description && (
                <Description className='mb-1 text-sm/6 text-gray-500'>
                    {description}
                </Description>
            )}
            <div className='grid grid-cols-1'>
                <HeadlessSelect
                    {...props}
                    id={id || uuid}
                    className='focus:outline-primary-600 col-start-1 row-start-1 block w-full appearance-none rounded-md border-0 bg-white py-1.5 pr-8 pl-3 text-base text-gray-900 ring-0 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:outline-gray-200 data-invalid:text-red-900 data-invalid:outline-red-300 data-invalid:focus:outline-red-600 sm:text-sm/6'
                    invalid={!!error}
                    required={required}
                >
                    {placeholder && (
                        <option value='' disabled>
                            {placeholder}
                        </option>
                    )}
                    {options
                        ? options.map(option => (
                              <option key={option.id} value={option.id}>
                                  {option.name}
                              </option>
                          ))
                        : children}
                </HeadlessSelect>
                {error && (
                    <Description className='col-start-1 mt-1 text-sm text-red-600'>
                        {error}
                    </Description>
                )}
            </div>
        </Field>
    );
};

export default Select;
